import { WINDOW } from '../../../types.js';
import { generateUniqueID } from './generateUniqueID.js';
import { getActivationStart } from './getActivationStart.js';
import { getNavigationEntry } from './getNavigationEntry.js';

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = function initMetric(name) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  var navEntry = getNavigationEntry();
  var navigationType = 'navigate';
  if (navEntry) {
    var _WINDOW$document, _WINDOW$document2;
    if ((_WINDOW$document = WINDOW.document) !== null && _WINDOW$document !== void 0 && _WINDOW$document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else if ((_WINDOW$document2 = WINDOW.document) !== null && _WINDOW$document2 !== void 0 && _WINDOW$document2.wasDiscarded) {
      navigationType = 'restore';
    } else if (navEntry.type) {
      navigationType = navEntry.type.replace(/_/g, '-');
    }
  }

  // Use `entries` type specific for the metric.
  var entries = [];
  return {
    name: name,
    value: value,
    rating: 'good',
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: entries,
    id: generateUniqueID(),
    navigationType: navigationType
  };
};
export { initMetric };